import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

const LegalLayout = ({ title, updated, children, testId }) => (
  <div data-testid={testId}>
    <Header />
    <main className="bg-white">
      <div className="mx-auto max-w-3xl px-6 py-16 md:px-10 md:py-24">
        <h1 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">{title}</h1>
        <p className="mt-3 text-sm font-medium text-slate-500">Last updated {updated}</p>
        <div className="mt-10 space-y-8 text-base leading-relaxed text-slate-700">{children}</div>
      </div>
    </main>
    <Footer />
  </div>
);

export const LegalSection = ({ heading, children }) => (
  <section>
    <h2 className="text-xl font-semibold text-navy">{heading}</h2>
    <div className="mt-3 space-y-3">{children}</div>
  </section>
);

export default LegalLayout;
